import { render, staticRenderFns } from "./StorageOrderIndex.vue?vue&type=template&id=378289bc&"
import script from "./StorageOrderIndex.vue?vue&type=script&lang=js&"
export * from "./StorageOrderIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports